import React from 'react'
import Head from "next/head";

const Gtm = ({gtmKey = ''}: {gtmKey: string}) => {
  return (
    gtmKey
    ? <Head>
        <script src="https://code.jquery.com/jquery-3.7.1.min.js" defer />
        <script async>
          {
            `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${gtmKey}');
            `
          }
        </script>
      </Head>
      : <></>
  )
}

export default Gtm
